import React, { useState, useEffect } from 'react'

export default function About() {
  const [pageData, setPage] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Set metadata
    document.title = "Profil - Frejlev Auto v/ Jacob Kvist"
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute('content', "Læs mere om Frejlev Auto v/ Jacob Kvist. Vi har over 30 års erfaring og er dit lokale, pålidelige autoværksted i Aalborg SV.")
    }

    // Fetch page content from CMS
    fetch('https://api.dev.auxo.dk/public/by-slug/da/frejlev-auto-dit-lokale-autovaerksted')
      .then(res => res.json())
      .then(data => {
        setPage(data)
        setLoading(false)
      })
      .catch(err => {
        console.error('Error fetching about page:', err)
        setLoading(false)
      })
  }, [])

  return (
    <div className="min-h-screen bg-gray-50 py-12 md:py-20 text-gray-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Breadcrumbs */}
        <div className="text-xs text-gray-500 uppercase tracking-wider mb-6 flex items-center gap-2">
          <span>Forside</span>
          <i className="fa-solid fa-chevron-right text-[8px]"></i>
          <span className="text-[#5cbe4f] font-semibold">Profil</span>
        </div>

        {loading ? (
          <div className="space-y-6 animate-pulse">
            <div className="h-10 bg-gray-200 rounded w-3/4"></div>
            <div className="h-6 bg-gray-200 rounded w-1/2"></div>
            <div className="space-y-3 pt-4">
              <div className="h-4 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded w-5/6"></div>
            </div>
          </div>
        ) : pageData ? (
          <article className="space-y-10 bg-white p-6 sm:p-10 rounded-2xl border border-gray-200 shadow-sm">
            {/* Header */}
            <div className="space-y-3">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-950 tracking-tight">
                Frejlev Auto - dit lokale autoværksted
              </h1>
              <div className="h-1 w-20 bg-[#5cbe4f] rounded"></div>
            </div>

            {/* Main Content */}
            <div 
              className="rich-text"
              dangerouslySetInnerHTML={{ 
                __html: pageData.content.replace(/<h1[^>]*>.*?<\/h1>/i, '') 
              }}
            />

            {/* Badges / Certifications Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-8 border-t border-gray-200">
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-6 flex items-start gap-4 shadow-sm">
                <div className="w-12 h-12 rounded-lg bg-[#5cbe4f]/15 text-[#5cbe4f] flex items-center justify-center text-2xl shrink-0">
                  <i className="fa-solid fa-shield-halved"></i>
                </div>
                <div>
                  <h3 className="text-gray-900 font-bold text-base mb-1">Dansk Bilbranche Råd</h3>
                  <p className="text-gray-600 text-xs leading-relaxed">
                    Som medlem af Dansk Bilbranche Råd er vi underlagt strenge kvalitetskrav og garantiordninger, hvilket sikrer dig en tryg og professionel behandling.
                  </p>
                  <a 
                    href="http://www.dbr.dk/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-[#5cbe4f] hover:text-[#4ca83e] text-xs font-semibold mt-3 transition-colors"
                  >
                    <span>Besøg DBR</span>
                    <i className="fa-solid fa-arrow-up-right-from-square text-[10px]"></i>
                  </a>
                </div>
              </div>

              <div className="bg-gray-50 border border-gray-200 rounded-xl p-6 flex items-start gap-4 shadow-sm">
                <div className="w-12 h-12 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center text-2xl shrink-0">
                  <i className="fa-solid fa-screwdriver-wrench"></i>
                </div>
                <div>
                  <h3 className="text-gray-900 font-bold text-base mb-1">Frie Danske Værksteder</h3>
                  <p className="text-gray-600 text-xs leading-relaxed">
                    Vi er en del af Frie Danske Værksteder. Det betyder, at du frit kan vælge os som værksted og bevare din bils fabriksgaranti 100%.
                  </p>
                  <a 
                    href="https://frievaerksteder.dk/hvad-er-et-frit-vaerksted/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-[#5cbe4f] hover:text-[#4ca83e] text-xs font-semibold mt-3 transition-colors"
                  >
                    <span>Læs om Frie Værksteder</span>
                    <i className="fa-solid fa-arrow-up-right-from-square text-[10px]"></i>
                  </a>
                </div>
              </div>
            </div>
          </article>
        ) : (
          <div className="text-center py-12">
            <p className="text-gray-500">Kunne ikke indlæse indholdet. Prøv igen senere.</p>
          </div>
        )}
      </div>
    </div>
  )
}
